import { Injectable, ViewChild } from '@angular/core';
import { AbstractControl } from "@angular/forms";
import { Observable, of } from "rxjs";
import { map, debounceTime, take, switchMap } from "rxjs/operators";
import { BaseService } from '../../shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class AsyncValidationService {
  showFlag: boolean = false;
  constructor(private baseService: BaseService) { }
  checkBillExist(event, question) {
    let value = event.target.value;
    // console.log('EVENT IN VALIDATION SERVICE', event);
    // console.log('QUESTION IN VALIDATION SERVICE', question);
    if (question.asyncValidation) {
      let application = question.asyncValidation.application;
      let resource = question.asyncValidation.resource;
      let query = question.asyncValidation.query_id;
      let args = question.asyncValidation.args;
      
      return this.baseService.get(query, args + ':' + value, resource, application)
      
    }    
  }
}
